import { useEffect, useRef } from 'react'
import {
  designPersonalizationContextIdUpdate as reduxDpcIdUpdate,
  designPersonalizationContextUpdate as reduxDpcDataUpdate,
  dpcsLoadingUpdate,
} from '~/client/store/designPersonalization/actions'
import { useDispatch } from 'react-redux'
import { contentUpdate } from '~/client/store/content'
import { useActiveSchemePreviewData } from '../Schemes'
import { ThunkDispatch } from '~/client/store/interface'

export const ReduxBridge = (): null => {
  const reduxDispatch = useDispatch<ThunkDispatch>()
  const { contextId, contextData, isUpdating, hasImages, hasText } = useActiveSchemePreviewData()

  const prevHasImages = useRef<boolean>(false)

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null

    if (isUpdating) {
      reduxDispatch(dpcsLoadingUpdate(true))
    } else {
      timeout = setTimeout(() => {
        reduxDispatch(dpcsLoadingUpdate(false))
      }, 50)
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdating])

  useEffect(() => {
    if (!hasText && !hasImages) {
      reduxDispatch(reduxDpcIdUpdate(undefined))
      reduxDispatch(reduxDpcDataUpdate(undefined))
    } else {
      reduxDispatch(reduxDpcIdUpdate(contextId))
      reduxDispatch(reduxDpcDataUpdate(contextData))
    }

    if (prevHasImages.current !== hasImages) {
      reduxDispatch(contentUpdate())
      prevHasImages.current = hasImages
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextId])

  return null
}
